'use client'

import { motion } from 'framer-motion'

interface Props {
  active?: boolean
  className?: string
  size?: number
  duration?: number
  from?: 'top' | 'right' | 'bottom' | 'left'
  to?: 'top' | 'right' | 'bottom' | 'left'
}

const fromRotate = {
  top: 0,
  right: 90,
  bottom: 180,
  left: 270,
}

const toRotate = {
  top: 0,
  right: 90,
  bottom: 180,
  left: 270,
}

export function ArrowIcon({ active, className, size = 20, duration = 0.3, from = 'top', to }: Props) {
  const initial = fromRotate[from]
  const animate = to ? toRotate[to] : initial
  return (
    <motion.div
      initial={{ rotate: initial }}
      animate={{ rotate: active ? animate : initial }}
      transition={{ duration }}
      className={className}
    >
      <svg width={size} height={size / 2} viewBox="0 0 20 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
          id="Vector"
          d="M19.5075 9.1299C19.6635 9.00352 19.7874 8.85316 19.8719 8.6875C19.9565 8.52184 20 8.34415 20 8.16468C20 7.98521 19.9565 7.80752 19.8719 7.64186C19.7874 7.4762 19.6635 7.32584 19.5075 7.19946L11.1822 0.402127C11.0274 0.274707 10.8432 0.17357 10.6403 0.104552C10.4374 0.0355337 10.2198 -3.70454e-07 10 -3.7878e-07C9.78019 -3.87106e-07 9.56256 0.0355337 9.35966 0.104552C9.15676 0.17357 8.9726 0.274707 8.81781 0.402127L0.492523 7.19946C0.33646 7.32584 0.212587 7.4762 0.128053 7.64186C0.0435196 7.80752 -4.02799e-07 7.98521 -4.11852e-07 8.16468C-4.20905e-07 8.34415 0.0435195 8.52184 0.128053 8.6875C0.212587 8.85316 0.33646 9.00352 0.492523 9.1299C0.647312 9.25732 0.831466 9.35846 1.03437 9.42748C1.23727 9.49649 1.4549 9.53203 1.67471 9.53203C1.89452 9.53203 2.11215 9.49649 2.31506 9.42748C2.51796 9.35846 2.70211 9.25732 2.8569 9.1299L10 3.2842L17.1431 9.1299C17.2979 9.25732 17.482 9.35846 17.6849 9.42748C17.8878 9.4965 18.1055 9.53203 18.3253 9.53203C18.5451 9.53203 18.7627 9.4965 18.9656 9.42748C19.1685 9.35846 19.3527 9.25732 19.5075 9.1299Z"
          fill="currentColor"
        />
      </svg>
    </motion.div>
  )
}
